import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { AppThunk } from 'core/common/store';

export const fetchNebulaAppLinkPending = createAction('user/FETCH_NEBULA_APP_LINK/pending');

export const fetchNebulaAppLinkSucceed = createAction<string>('user/FETCH_NEBULA_APP_LINK/succeed');

export const fetchNebulaAppLinkFailed = createAction('user/FETCH_NEBULA_APP_LINK/failed');

export const fetchNebulaAppLink =
  (host?: string): AppThunk =>
  async (dispatch, _, context) => {
    const { userService, loggingService } = context;
    dispatch(fetchNebulaAppLinkPending());

    try {
      const { link } = await userService.getNebulaAppDownloadLink(host);

      dispatch(fetchNebulaAppLinkSucceed(link));
    } catch (e) {
      dispatch(fetchNebulaAppLinkFailed());
      const err = normalizeError(e);
      loggingService.error(err);
    }
  };
